module.exports = __webpack_public_path__ + "img/logo.fc9b044a.png";